import { render, staticRenderFns } from "./releaseGoods.vue?vue&type=template&id=4245e7ec&scoped=true&"
import script from "./releaseGoods.vue?vue&type=script&lang=js&"
export * from "./releaseGoods.vue?vue&type=script&lang=js&"
import style0 from "./releaseGoods.vue?vue&type=style&index=0&id=4245e7ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4245e7ec",
  null
  
)

export default component.exports